module.exports = __webpack_public_path__ + "img/gos_pochta.png";